import "./iefix";//勿删
import Passport from "./index";
(window as any).ePassport = {
    logout: () => {
        Passport.logout();
    },
    clearCookies: () => {
        Passport.clearCookies();
    },
    reloadTEAMS: () => {
        Passport.reloadTEAMS();
    },
    showClearPrompt: () => {
        Passport.showClearPrompt();
    },
    lockPage: (callback?: Function) => {
        Passport.lockPage(callback);
    },
    updateCache: (field: string, value: any) => {
        Passport.updateCache(field, value);
    },
    // websocketSDK: Passport.websocketSDK,
    isFreePassUrl: Passport.isFreePassUrl || false
}
export default Passport;
